import { Context, type Effect } from 'effect';

import type { Page, PageRequest } from '@vs-shop/domain/pagination';

import type { ProductSummary } from '../productSchema';
import type { ProductCatalogueError } from './errors';

/**
 * The whole catalogue, one page at a time, in the backend's own order.
 *
 * Separate from `CategoryListing.products` rather than an optional taxon on it.
 * The two are different reads: this one is what a homepage rail shows when the
 * backend names no featured set, and that one is a category's contents. An
 * optional filter that silently widens a category listing to the whole shop is
 * the kind of parameter that gets forgotten, and the two reads want different
 * spans besides.
 */
export type ProductCatalogueService = {
  readonly products: (
    request: PageRequest
  ) => Effect.Effect<Page<ProductSummary>, ProductCatalogueError>;
};

export class ProductCatalogue extends Context.Service<ProductCatalogue, ProductCatalogueService>()(
  '@engine/Capability/ProductCatalogue'
) {}
